import { render } from "./TelegramForm.vue?vue&type=template&id=523725f6&lang=pug"
import script from "./TelegramForm.vue?vue&type=script&lang=js"
export * from "./TelegramForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__